import { toast } from "react-toastify";
import Api from "./api";
import { URL } from "../Redux/common/url";
// import { URL } from "./url";
// const Token = require("../../Utils/Auth/Token");
const Token = require("../Utils/Auth/Token");

export const signinSeller = async (data, navigate) => {
  try {
     
    const response = await Api.post(`${URL.signinSeller}`, data);

    if (response?.data?.success) {
      toast.success(response?.data?.message);

      if (data?.role_name == "User") {
        Token.setToken(response?.data?.api_token);

        const lsValue = JSON.stringify(response?.data?.data);
        Token.setUserDetail(lsValue);
        // navigate(-1);
        navigate("/dashboard"); //smth
        // window.location.href = "/accounts";
      } else {
        Token.setvendorToken(response?.data?.api_token);

        const lsValue = JSON.stringify(response?.data?.data);
        Token.setUserDetail(lsValue);
        navigate("/dashboard");
        // navigate(-1);
        // smth
        // window.location.href = "/seller";
      }
    } else {
      toast.error(response?.data?.message);
    }
  } catch (error) {
    console.log(error);
    toast.error(error?.response?.data?.message);
  }
};
